<template>
    <div class="c-modal-wrapper c-has-dark-blue-header">
      <!-- Application Header -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <div class="c-grid-row">
              <div class="c-col-12">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Zatvori</b></button>                
              </div>
            </div>
          </div>
        </div>
      </header> 
      <!-- Body content -->
      <div class="c-modal-body c-has-skewed-background c-to-full-bottom">
        <div class="c-responsive-container c-p-bottom-10">
          <div>
            <!-- Basic info of Regular Guest -->
            <div class="c-regular-guest-details-block">
              <div class="c-has-event-title">
                <b v-if="selectedGuestObject && selectedGuestObject.firstName">{{selectedGuestObject.firstName}}</b>
                <b v-if="selectedGuestObject && selectedGuestObject.lastName">{{selectedGuestObject.lastName}}</b>
              </div>
              <div class="c-has-small-details" style="font-size:14px;">
                Ukupna potrosnja gosta:
                <span v-if="guestTotalBillsSum">
                  <b>{{guestTotalBillsSum | glFilter_numberToCommas}}</b> RSD
                </span>
                <span v-else>--</span>
              </div>
            </div>
            <!-- Section Title -->                 
            <!-- List of all tables for event -->
            <transition name="fade" mode="out-in">
              <div v-if="listOfSpendingHistory">
                <div class="c-event-tables-title-box">Lista prethodnih rezervacija koje je gost imao</div>
                <ul class="c-items-list" v-if="true">
                  <li class="c-single-regular-guest-spending" v-bind:class="{'c-expanded' : indexOfExpandedItem === itemKey}"
                  v-for="(singleReservationItem, itemKey) in listOfSpendingHistory" v-on:click="toggleExpandDetailsIndex(itemKey)">
                    <table class="c-content-as-table">
                      <tbody>
                        <tr>
                          <!-- Date -->
                          <td class="c-has-table-number">
                              <!-- Table number -->
                              <span v-if="singleReservationItem.tableShortName"><b>{{singleReservationItem.tableShortName}}</b></span>
                              <span v-else>Unk</span>
                          </td>
                          <!-- Text content -->
                          <td class="c-has-guest-name">
                            <!-- Event Name -->
                            <div>
                              <b v-if="singleReservationItem.eventName">{{singleReservationItem.eventName}}</b>
                              <b v-else>Unknown</b>
                            </div>
                            <!-- Table bill -->
                            <div class="c-fs-14">
                              <span>
                                <b v-if="singleReservationItem.eventDate">{{singleReservationItem.eventDate, 'ddd, D.MMM.YYYY.' | glFilter_returnFormatedDate}}</b>
                                <b v-else>--</b>
                                /
                              </span>                              
                              <span>
                                Račun:
                                <b v-if="singleReservationItem.tableBill">{{singleReservationItem.tableBill}}</b>
                                <b v-else>--</b>
                              </span>
                            </div>
                          </td>
                          <!-- Action buttons -->
                        </tr>
                      </tbody>
                    </table>
                    <!-- Expanded details -->
                    <transition name="fade" mode="out-in">
                      <div class="c-expanded-details-wrapper" v-if="indexOfExpandedItem === itemKey">
                        <div>Broj stola: <b v-if="singleReservationItem.tableShortName">{{singleReservationItem.tableShortName}}</b></div>
                        <div>
                          Ime konobara:
                          <b v-if="singleReservationItem.tableWaiterUid">{{singleReservationItem.tableWaiterUid | glFilter_waiterFullName}}</b>
                          <b v-else>--</b>
                        </div>
                        <div>Spisak naručivanog pića: <b v-if="singleReservationItem.tableOrderedDrinks">{{singleReservationItem.tableOrderedDrinks}}</b></div>
                        <div>Spisak gratisa: <b v-if="singleReservationItem.tableComplimentaryDrinks">{{singleReservationItem.tableComplimentaryDrinks}}</b></div>
                      </div>
                    </transition>                    
                    <!-- Action buttons -->
                    <div class="c-has-buttons">
                      <button class="c-btn c-btn-action-on-white">
                        <i class="fa" aria-hidden="true" v-bind:class="[indexOfExpandedItem === itemKey ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down']"></i>
                      </button>
                    </div>
                  </li>
                </ul>
                <div v-else><b>Nothing to show</b></div>
              </div>
              <!-- No content message -->
              <emo-well-comp 
                v-else
                input-well-type="no-content" 
                input-txt-msg="Gost trenutno nema istoriju rezervacija"
                input-txt-color="#fff"
              ></emo-well-comp>
            </transition>
          </div>
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <!-- <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          <div class="c-grid-row c-footer-action-buttons-wrap">
            <div class="c-col-6 c-align-right">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-success" v-on:click="saveChanges()"><i class="fa fa-check" aria-hidden="true"></i> <b>Sačuvaj</b></button>
            </div>
            <div class="c-col-6 c-align-left">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-danger" v-on:click="cancelChanges()"><i class="fa fa-times" aria-hidden="true"></i> <b>Otkaži</b></button>
            </div>
          </div>
        </div>
      </footer> -->
    </div>
</template>

<script>
import router from '@/router/index'
import EventBus from '@/EventBus'
import moment from 'moment'
import {firebaseDB} from '@/firebase';
import EmoWellComp from "@/components/wells/EmoWellComp";
export default {
  name: 'ModalRegularGuestSpending',
  props: ['inputModalData'],
  components: {
    EmoWellComp: EmoWellComp
  },  
  data () {
    return {
      msg: 'ModalRegularGuestSpending modal',
      selectedGuestObject: null,
      indexOfExpandedItem: null,
      listOfSpendingHistory: null,
      guestTotalBillsSum: null,
      isLoading: [],
      resolve: null,
      reject: null
    }
  },
  methods: {
    ///
    toggleExpandDetailsIndex: function (inputItemIndex) {
      if (this.indexOfExpandedItem === inputItemIndex){
        this.indexOfExpandedItem = null;
      }else{
        this.indexOfExpandedItem = inputItemIndex;
      }
    },
    // ~ get all Spending history
    getGuestSpendingHistory: function (inputRegularGuestUid) {
      firebaseDB.ref('listOfRegularGuestsHistory/' + inputRegularGuestUid).once('value').then(
        function(snapshot) {
          this.listOfSpendingHistory = snapshot.val();
          //console.log('Regular Guest History received: ' + JSON.stringify(this.listOfSpendingHistory, null, 2) );
          this.sumAllGuestBills();
        }.bind(this),
        function(error) {
          // The Promise was rejected.
          console.log('Regular Guest History FAILDED: ' + error );
          //console.error(error);
          this.reject();
        }.bind(this)
      );
    },
    //
    sumAllGuestBills: function () {
      if (this.listOfSpendingHistory){
        for (var key in this.listOfSpendingHistory) {
          if (this.listOfSpendingHistory.hasOwnProperty(key) && this.listOfSpendingHistory[key].tableBill) {
            var newBill = parseFloat(this.listOfSpendingHistory[key].tableBill);            
            this.guestTotalBillsSum = this.guestTotalBillsSum + newBill;
            this.guestTotalBillsSum.toLocaleString('en')
          }
        }     
      }
    },
    // ~ When we want to discard changes
    cancelChanges: function (){
      this.reject();
    }
  },
  created () {
    //console.log('~ created- ModalRegularGuestSpending component!');
    if (this.inputModalData){
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      if (this.inputModalData.dataForModal){
        this.selectedGuestObject = this.inputModalData.dataForModal;
        if (this.selectedGuestObject && this.selectedGuestObject.uid){
          this.getGuestSpendingHistory(this.selectedGuestObject.uid);
        }
      }      
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
    }
  },
  mounted () {
    //console.log('~ mounted - ModalRegularGuestSpending component!');
  },
  destroyed () {
    //console.log('~ destroyed- ModalRegularGuestSpending component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/regularGuests/ModalRegularGuestSpending.vue